import styled, { css } from 'styled-components';
import { Link } from 'react-router-dom';
import Card from 'components/Card';
import ButtonIcon from 'components/ButtonIcon';
import { color } from 'theme';
import {
    GREY_400,
    GREY_500,
    GREY_800,
    PURPLE_500,
    PURPLE_100,
    DIVIDER,
} from '../../../constants';

export const StyledCard = styled(Card)`
    height: calc(100vh - 161px);
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
`;

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    align-items: stretch;
    flex: 1;
    align-self: stretch;
`;

export const Header = styled.div`
    display: flex;
    width: 100%;
    flex-direction: row;
    justify-content: space-between;
    text-align: center;
    padding: 1.5rem 1.5rem 1.5rem 1.5rem;
`;

export const HeaderLeft = styled.div`
    display: flex;
    align-items: center;
    gap: 0.75rem;
`;

export const Info = styled.div`
    display: flex;
    flex-direction: column;
    align-items: start;
    margin-right: 1rem;
    gap: 0.35rem;
    flex: 1;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
`;

export const CardTitle = styled.h2`
    font-size: 1.125rem;
    font-weight: 400;
    line-height: 1.5rem;
    letter-spacing: 0.0125rem;
    white-space: nowrap;
    color: ${GREY_400};
`;

export const CardSubtitle = styled.h3`
    font-size: 0.9375rem;
    font-weight: 300;
    line-height: 1.25rem;
    text-align: left;
    white-space: nowrap;
    color: ${GREY_400};
`;

export const StyledButtonIcon = styled(ButtonIcon)`
    svg {
        width: 1.625rem !important;
        height: 1.625rem !important;
        font-size: 1.625rem !important;
    }
`;

export const Divider = styled.div`
    display: flex;
    align-self: stretch;
    height: 0.0625rem;
    background: ${DIVIDER};
`;

export const Content = styled.div`
    display: flex;
    padding: 1.5rem 1.25rem;
    align-items: stretch;
    gap: 1.25rem;
    flex: 1 0 0;
    align-self: stretch;
`;

export const LeftColumn = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    width: 15.625rem;
    gap: 0;
`;

export const RightColumn = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    flex: 1 0 0;
    align-self: stretch;
`;

export const Options = styled.ul`
    display: flex;
    flex-direction: column;
    list-style: none;
    align-self: stretch;
`;

export const MenuItemContainer = styled.li`
    display: flex;
    flex-direction: row;
    width: 100%;
`;

export const StyledLink = styled(Link).withConfig({
    shouldForwardProp: (prop) => !['isActive'].includes(prop),
})<{ isActive: boolean; }>`
    display: flex;
    flex-direction: row;
    align-items: center;
    text-decoration: none;
    width: 100%;
    color: ${GREY_500};
    padding: 0.6rem 1rem;
    margin: 2.5px 0;
    border-radius: 5px;
    font-size: 15px;
    transition: background-color 0.2s ease-in-out;
    font-weight: 300;

    &:hover, &:focus, &:active {
        color: ${GREY_500};
        text-decoration: none;
        background-color: ${color('background.highlight')};
    }

    svg {
        width: 1.125rem !important;
        height: 1.125rem !important;
        font-size: 1.125rem !important;
    }

    ${(props) => props.isActive && css`
        color: ${PURPLE_500};
        background: ${PURPLE_100};
        box-shadow: none;

        &:hover, &:focus, &:active {
            color: ${PURPLE_500};
            background: ${PURPLE_100};
        }
    `}
`;

export const Section = styled.div`
    display: flex;
    flex-direction: column;
    gap: 1.5rem;
    align-self: stretch;
`;

export const SectionHeader = styled.div`
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
`;

export const SectionTitle = styled.h3`
    font-size: 1.125rem;
    font-weight: 400;
    line-height: 1.5rem;
    letter-spacing: 0.0125rem;
    color: ${GREY_400};
`;

export const SectionContent = styled.div`
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    gap: 1rem;
`;

export const ChannelField = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 1rem;
    gap: 1rem;
    width: 100%;
    overflow: hidden;
`;

export const ChannelLabelContainer = styled.div`
    display: flex;
    align-items: center;
    gap: 1rem;
    flex: 1 0 0;
    overflow: hidden;
    text-overflow: ellipsis;
`;

export const ChannelIconContainer = styled.span`
    display: flex;
    justify-content: center;
    align-items: center;

    & > svg {
        width: 1.875rem;
        height: 1.875rem;
    }
`;

export const ChannelLabelText = styled.span`
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    font-size: 0.9375rem;
    font-weight: 400;
    line-height: 1.5rem;
    color: #393841;
`;

export const ChannelLabel = styled.label`
    font-size: 0.8125rem;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    color: ${GREY_800};
`;

export const FormFooter = styled.footer`
    display: flex;
    align-items: flex-end;
    gap: 1rem;
    align-self: stretch;
    padding-top: 0.5rem;
`;
